
import { combineReducers } from 'redux';

import map from './map';
import odrudaDetail from './odrudaDetail';
import odrudaSsr from './odrudaSsr';
import odrudaList from './odrudaList';
import tratDetail from './tratDetail';
import tratList from './tratList';

export default combineReducers({
    map,
    odrudaDetail,
    odrudaSsr,
    odrudaList,
    tratDetail,
    tratList
});
